<template>
  <v-card outlined :loading="loading" rounded="lg">
    <h6 class="mx-4 my-3">Registro de entradas</h6>
    <v-data-table
      :headers="headers"
      :items="entries"
      :items-per-page="10"
      sort-by="createdAt"
      sort-desc
      dense
    >
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | date("DD/MM HH:mm:ss") }}
      </template>
      <template v-slot:item.ticketId="{ item }">
        #{{ item.ticketId | shortId }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-chip :color="types[item.action].color" x-small label>
          <v-icon left x-small>
            {{ types[item.action].icon }}
          </v-icon>
          {{ types[item.action].text }}
        </v-chip>
      </template>
      <template v-slot:item.ticketBlock.name="{ item }">
        {{ ticketGroups[item.Ticket.ticketBlockId]?.name }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "SessionEntriesTimeline",
  components: {
    VueApexCharts,
  },
  props: {
    session: {
      type: Object,
    },
    entries: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      types: {
        IN: {
          text: "Entrada",
          color: "info",
          icon: "mdi-login",
        },
        OUT: {
          text: "Saída",
          color: "warning",
          icon: "mdi-logout",
        },
      },
      headers: [
        { text: "Data", value: "createdAt" },
        { text: "Ingresso", value: "ticketId" },
        { text: "Tipo", value: "action" },
        { text: "Setor", value: "ticketBlock.name" },
      ],
    };
  },
  computed: {
    ticketGroups() {
      if (!this.session) return {};
      return this.session?.TicketBlocks?.reduce((acc, ticketBlock) => {
        if (!acc[ticketBlock.id]) acc[ticketBlock.id] = ticketBlock.TicketGroup;
        return acc;
      }, {});
    },
  },
};
</script>
